import * as React from 'react'

import { useTranslation } from '../../../hooks/useTranslation'
import { useRecruiterSearch } from './RecruiterSearchProvider'
import { HeartOutlineIcon, HeartSolidIcon } from './Icons'
import { cn } from '../../../lib/utils'

export default function RecruiterCard({ recruiter }) {
  const { t } = useTranslation('RecruiterCard')
  const {
    selectedRecruiter,
    handleSelectRecruiter,
    isSavedRecruiter,
    addToMyRecruiters,
    removeFromMyRecruiters,
    isSavedRecruiterCompany,
  } = useRecruiterSearch()
  const selected = selectedRecruiter && selectedRecruiter?.id === recruiter?.id

  const description = recruiter.description
    ? recruiter.description
        .replace(/<[^>]*>?/gm, ' ')
        .replace(/\|\|\|/g, '')
        .replace(/\|\|/g, '')
        .split(' ')
        .filter((word) => word.length <= 40)
        .join(' ')
    : ''

  const toggleRecruiter = () => {
    if (isSavedRecruiter(recruiter)) {
      removeFromMyRecruiters(recruiter)
    } else addToMyRecruiters(recruiter)
  }

  const handleCardClick = (event) => {
    handleSelectRecruiter(recruiter)(event)
  }

  return (
    <li
      className="relative flex cursor-pointer flex-row gap-4 rounded-2xl border-2 p-4 transition-colors hover:border-gray-400 hover:shadow-lg data-[selected=true]:border-intoo-blue-bright"
      data-selected={selected}
      onClick={handleCardClick}
    >
      <div className="relative flex min-w-full flex-col gap-4">
        <div
          onClick={toggleRecruiter}
          className={cn(
            'absolute right-0',
            isSavedRecruiterCompany(recruiter) && 'text-[#A50000]',
          )}
        >
          <SavedStatusIcon recruiter={recruiter} />
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-xs">
            {!!recruiter.posted_on_month_day && (
              <>
                {t('posted')} {recruiter.posted_on_month_day}
              </>
            )}
          </div>
        </div>

        <div className="flex flex-row justify-start gap-4">
          {/* <CompanyImage recruiter={recruiter} /> */}

          <div className="flex flex-col gap-1">
            <h4 className="pr-10 font-extrabold">{recruiter.name}</h4>
            <div className="flex flex-row text-xs">
              <div className="whitespace-nowrap">{recruiter.city_state}</div>
            </div>
          </div>
        </div>
        <p className="line-clamp-3 text-xs">{description}</p>
      </div>
    </li>
  )
}

const SavedStatusIcon = ({ recruiter }) => {
  const { isSavedRecruiterCompany } = useRecruiterSearch()

  const saved = isSavedRecruiterCompany(recruiter)

  if (saved) return <HeartSolidIcon />
  return <HeartOutlineIcon />
}
